// Candidate-pool controls matter only when auto-design chooses that equipment.
// Keep saved preferences intact while a project pins a particular model, but
// do not send stale filters that could reject the pinned selection.
export function autoDesignCandidateFilters(params = {}, selectedModule, selectedInverter) {
  const hasModule = Boolean(String(selectedModule || "").trim());
  const hasInverter = Boolean(String(selectedInverter || "").trim());

  return {
    module_technologies: hasModule ? [] :
      (Array.isArray(params.moduleTechnologies) ? params.moduleTechnologies : []),
    modules_owned_only: !hasModule && Boolean(params.modulesOwnedOnly),
    inverter_conversion_model: hasInverter ? undefined :
      (params.inverterConversionModel || undefined),
    inverter_phases: hasInverter ? "both" :
      (["one", "three", "both"].includes(params.inverterPhases) ? params.inverterPhases : "both"),
    inverters_owned_only: !hasInverter && Boolean(params.invertersOwnedOnly),
  };
}
